<template>
  <v-app
    :class="$store.getters.LANGUAGE == 'fa' ? 'vazir-font-fd' : 'vazir-font'"
  >
    <my-navigation></my-navigation>
    <v-main>
      <router-view></router-view>
    </v-main>
    <my-footer></my-footer>
  </v-app>
</template>

<script>
import MyNavigation from "@/components/Navigation";
import MyFooter from "@/components/Footer";

export default {
  name: "PrivateLayout",
  components: {
    MyNavigation,
    MyFooter
  }
};
</script>
